export const en = {
  translation: {
    layout: {
      graphsContainer: {
        hideOverview: 'Hide overview',
        hideOverviewFor: 'Hide overview for',
        showOverview: 'Show overview',
        showOverviewFor: 'Show overview for',
      },
    },
    auth: {
      somethingWrong: 'Oops! Something went wrong!',
      tryAgain: 'Try again',
    },
    activityLog: {
      title: 'Activity Log',
      tabs: {
        productsManagement: 'Products Management',
        simProvisioning: 'Sim Provisioning',
      },
      productsManagement: {
        uploadFailed: 'Products management upload failed',
        template: {
          productsManagementTemplate: 'Product Management template',
        },
        table: {
          headers: {
            numberOdProducts: 'No. of Products',
          },
        },
      },
    },
    bulkProvisioning: {
      manualAction: 'Manual action',
      fileUpload: 'File upload',
      order: 'Order',
      downloadFailedResults: 'Download failed results',
      downloadInput: 'Download input file',
      dragAndDrop: 'Drag& drop first file or click here to Upload file',
      processedDate: 'Processed date',
      title: 'Activity Log',
      uploadDateFrom: 'Upload date from',
      uploadDateTo: 'Upload date to',
      viewDetails: 'View details',
      source: 'Source',
      processingFinishedTime: 'Processing Finished Time',
      fileUploadingInfo: 'You’re uploading file:',
      downloadTemplate: 'Download Template',
      masterTemplate: 'Master template',
      bulkProvisioning: 'Bulk provisioning',
      unitDataAdjustment: 'Unit data adjustment',
      simProfileManagement: 'SIM Profile Management',
      bulkProvisioningFailed: 'Bulk Provisioning Failed',
      errorReportButton: 'Error Report',
      errorReportDialogTitle: 'Generate error report',
      errorReportDialogSubtitle:
        "We'll process your request in the background. \n You'll receive an email with a download link when it's ready.",
      errorReportDateInputLabel: 'Error report date',
      errorReportSuccessMessage: "You'll receive an email with a download link when it's ready.",
      errorReportFailureMessage: 'Something went wrong.',
      errorReportDatePickerError: 'Please select a date within the past 90 days.',
    },
    dashboard: {
      title: 'Dashboard',
      accountFilter: 'Account',
      placeholders: {
        selectAccount: 'Filter by an account to view details.',
        selectSingleAccount: 'Filter by a single account to view details.',
        selectTariff: 'Select tariff to see usage',
        selectProduct: 'Select product to see usage',
      },
      subscriptionsStatusChart: {
        title: 'Subscription Status',
        legend: {
          test: 'Test',
          active: 'Active',
          deactivated: 'Deactivated',
        },
      },
      cumulativeUsageChart: {
        title: 'Usage',
        legend: {
          data: 'data',
          ovareage: 'ovareage',
        },
      },
      activeInSessionChart: {
        title: 'Active in Session',
        legend: {
          inSession: 'In Session',
          outOfSession: 'Out of Session',
        },
      },
      rSimStatusChart: {
        title: 'rSIM Status',
        legend: {
          primary: 'Primary',
          backup: 'Backup',
          disconnected: 'Disconnected',
        },
      },
      inventoryChart: {
        title: 'Inventory',
      },
    },
    locations: {
      title: 'Last Known Location',
      banner: {
        message:
          'Locations is in beta. Data and features are still being refined and some results may be incomplete. Spotted something odd? <supportLink>Raise a support issue.</supportLink>',
        dismissAriaLabel: 'Dismiss locations banner',
      },
      filters: {
        title: 'Filters',
        selectAccount: 'Select an Account or Organisation to view results',
        country: {
          label: 'Last Known Country',
          placeholder: 'Select Last Known Country',
        },
        lastRefreshed: 'Last refreshed',
        lastUpdatedZeroTime_one: 'less than {{count}} second ago',
        lastUpdatedZeroTime_other: 'less than {{count}} seconds ago',
        view: {
          title: 'View',
          product: 'Product',
          activity: 'Activity',
        },
        productType: {
          label: 'Product Type',
          sim: 'SIM',
          esim: 'eSIM',
          rsim: 'rSIM',
        },
        activity: {
          label: 'Activity',
          '24h': 'Active 24h',
          '30d': 'Active 30d',
          '90d': 'Active 90d',
        },
      },
      cards: {
        active24h: 'Active 24h',
        active30d: 'Active 30d',
        active90d: 'Active 90d',
        countries: 'Countries',
      },
      graph: {
        title: 'Product Distribution by Country',
        subtitle_one: 'country with active devices',
        subtitle_other: 'countries with active devices',
        noData: 'No data',
        noLocations: 'Location Unknown',
        noLocationsShort: 'N/A',
        selectedSeries: {
          message_one: '{{series}} - {{count}} product across last known countries',
          message_other: '{{series}} - {{count}} products across last known countries',
          clearSelection: 'Clear selection',
          viewDataTable: 'View {{series}} data table',
        },
      },
      map: {
        title: 'Location Map',
        selectAnAccount: 'Select account to see details',
        disclaimer:
          'Locations shown on this map are approximate and based on cellular network data. They represent general service areas and are not precise, real-time GPS coordinates.',
        selectedDevice: 'Selected Device',
      },
      details: {
        viewFleet: 'View Fleet Map',
      },
    },

    tag: {
      signLimits: 'Tag can’t be longer that 50 characters',
      tagsLimit: 'Tags limit reached',
    },
    tariffSummary: {
      tariffSummary: 'Tariff Summary',
      lastUpdated: 'Last updated',
      tableHeaders: {
        tariffCode: 'Tariff Code',
        tariffDescription: 'Tariff Description',
        alertConfiguration: 'Alert',
        active: 'Active',
        data: 'Data (MB)',
        forecastData: 'Forecast (MB)',
        poolDataAllowance: 'Pool Data Allowance (MB)',
        voice: 'Voice',
        forecastVoice: 'Forecast',
        poolVoiceAllowance: 'Pool Voice Allowance ',
        sms: 'SMS (msg)',
        forecastSms: 'Forecast (msg)',
        poolSMSAllowance: 'Pool SMS Allowance (msg)',
      },
      filters: {
        organisation: 'Account or Organisation',
        organisationPlaceholder: 'Select Account or Organisation',
      },
      table: {
        selectAccount: 'Select an Account or Organisation to view results',
        progessBarDescription: 'Based on current average\nmonthly usage (indicative)',
        viewDetails: 'View details',
        noData: 'No data',
        noDataForBillingMonth: 'No data for the current billing month',
        sorting: {
          dataAsc: 'Data by ACS',
          dataDecs: 'Data by DECS',
          voiceAsc: 'Voice by ACS',
          voiceDecs: 'Voice by DECS',
          smsAsc: 'SMS by ACS',
          smsDecs: 'SMS by DECS',
          usedPercetageAcs: 'Used Percentage by ACS',
          usedPercetageDesc: 'Used Percentage by DESC',
        },
        usageAlert: {
          alertTooltipHeader: 'Alert enabled for',
          dataThresholdPercentage: 'Data usage: {{dataThreshold}}%',
          voiceThresholdPercentage: 'Voice usage: {{voiceThreshold}}%',
          smsThresholdPercentage: 'SMS usage: {{smsThreshold}}%',
          alertOn: 'Alert on',
          alertAny: 'Any',
          alertOff: 'Alert off',
          selectedTariff_one: 'Tariff selected',
          selectedTariff_other: 'Tariffs selected',
          setUpAlert: 'Configure alert',
          setUpAlerts: 'Configure Alerts',
          clearSelection: 'Clear selection',
          configureAlert: 'Configure Alert Settings',
          configureAlertInfo: 'You will receive daily usage alerts via email',
          configureCountInfo_one: 'Set up usage threshold alerts for {{count}} selected tariff.',
          configureCountInfo_other: 'Set up usage threshold alerts for {{count}} selected tariffs.',
          configureTypeInfo: 'Choose the threshold for each alert type.',
          dataThreshold: 'Data Usage Alert',
          dataThresholdInfo: 'Send email when data usage reaches {{percentage}}% of allowance',
          voiceThreshold: 'Voice Usage Alert',
          voiceThresholdInfo: 'Send email when voice usage reaches {{percentage}}% of allowance',
          smsThreshold: 'SMS Usage Alert',
          smsThresholdInfo: 'Send email when SMS usage reaches {{percentage}}% of allowance',
          applyConfiguration_one: 'Apply to {{count}} tariff',
          applyConfiguration_other: 'Apply to {{count}} tariffs',
          alertConfigurationSuccess_one: 'Alert configuration applied to {{count}} tariff',
          alertConfigurationSuccess_other: 'Alert configuration applied to {{count}} tariffs',
          alertConfigurationError: 'Error occured while configuring alerts',
          savingWarning:
            'Saving now will override existing settings for all selected tariffs. \nIndividual differences will be lost.',
        },
      },
    },
    productSummary: {
      productSummary: 'Product Summary',
      lastUpdated: 'Last updated',
      tableHeaders: {
        productCode: 'Product Code',
        active: 'Active',
        data: 'Data (MB)',
        voice: 'Voice',
        sms: 'SMS (msg)',
      },
      filters: {
        organisation: 'Account or Organisation',
        organisationPlaceholder: 'Select Account or Organisation',
      },
      table: {
        selectAccount: 'Select an Account or Organisation to view results',
        sorting: {
          dataAsc: 'Data by ACS',
          dataDecs: 'Data by DECS',
          voiceAsc: 'Voice by ACS',
          voiceDecs: 'Voice by DECS',
          smsAsc: 'SMS by ACS',
          smsDecs: 'SMS by DECS',
        },
      },
    },
    common: {
      selected: 'selected',
      blank: 'blank',
      dcpEnterprise: 'DCP Enterprise',
      enterprise: 'Enterprise',
      idSearch: 'ID Search',
      zoom: 'Zoom',
      zoomIn: 'Zoom in',
      zoomOut: 'Zoom out',
      zoomOutMax: 'Zoom out max',
      connectionId: 'Connection ID',
      order: 'Order',
      activeTime: 'Active time',
      accountName: 'Account Name',
      accountNumber: 'Account Number',
      installerName: 'Organisation',
      installerRef: 'Organisation Number',
      active: 'Active',
      additionalActions: 'additional actions',
      applyFilters: 'Apply filters',
      cancel: 'Cancel',
      clearFilters: 'Clear filters',
      client: 'Client',
      close: 'Close',
      confirm: 'Confirm',
      currentIp: 'Current IP',
      dropFile: 'Drop file here',
      eid: 'EID',
      expandRow: 'expand row',
      fail: 'Fail',
      failed: 'Failed',
      fileName: 'File name',
      filters: 'Filters',
      iccid: 'ICCID',
      id: 'ID',
      imsi: 'IMSI',
      inactive: 'Inactive',
      disconnected: 'Disconnected',
      inventory: 'Inventory',
      label: 'Label',
      logout: 'logout',
      managementIp: 'Management IP',
      minTextLong: 'Minimum {{number}} characters',
      mno: 'MNO',
      msisdn: 'MSISDN',
      noAccess: 'You do not have permission to view this data',
      noRecords: 'No records',
      noResults: 'No results found',
      none: 'None',
      numberOfCards: 'No. of cards',
      organisation: 'Organisation',
      plan: 'Plan',
      search: 'Search',
      searchText: 'Search {{text}}',
      source: 'Source',
      status: 'Status',
      mnoStatus: 'MNO Status',
      success: 'Success',
      uploadDate: 'Upload date',
      uploadTime: 'Upload time',
      uploadFile: 'Upload file',
      usage: 'Usage (MB)',
      data: 'Data (MB)',
      refresh: 'Refresh',
      unknown: 'Unknown',
      pageNotFound: 'Page not found',
      backToDashboard: 'Back to dashboard',
      backToHomepage: 'Back to homepage',
      downloading: 'Downloading',
      export: 'Export',
      exportFailed: 'Export failed',
      requestFailed: 'Request Failed',
      simulationRunning: 'Simulation running',
      simulateOutage: 'Simulate outage',
      somethingWrong: 'Something went wrong!',
      simulateOutageRunning: 'Outage simulation running',
      primary: 'Primary',
      secondary: 'Secondary',
      backup: 'Backup',
      connected: 'Connected',
      inSession: 'In session',
      outSession: 'Out of session',
      rowsPerPage: 'Rows per page',
      sessions: 'Sessions',
      orderNumber: 'Order Number',
      common: 'Upload date',
      to: 'to',
      from: 'from',
      customerPlan: 'Customer Plan',
      minutes: 'minutes',
      hour: 'hour',
      day: 'day',
      week: 'week',
      month: 'month',
      tag: 'Tag',
      tags: 'Tags',
      asc: 'Ascending',
      desc: 'Descending',
      toSort: 'Sort',
      profile: 'Profile',
      any: 'Any',
      on: 'On',
      off: 'Off',
      type: 'type',
      account: 'Account',
      limitReached: 'Limit reached',
      resetColumnWidth: 'Reset column width',
      combinedRows: 'Combined rows',
      revertToDefault: 'Revert to default configuration',
      sortByDescending: 'Sort by descending',
      sortByAscending: 'Sort by ascending',
      clear: 'Clear',
      inMinuteUsage: 'Voice Usage MT',
      outMinuteUsage: 'Voice Usage MO',
      inTextUsage: 'SMS Usage MT (Msg)',
      outTextUsage: 'SMS Usage MO (Msg)',
      inMinuteUsageProduct: 'Voice (MT)',
      outMinuteUsageProduct: 'Voice (MO)',
      inTextUsageProduct: 'SMS MT (Msg)',
      outTextUsageProduct: 'SMS MO (Msg)',
      admin: 'Admin',
      toHigherThanFromError: 'Value must be higher than "From"',
      add: 'Add',
      edit: 'Edit',
      delete: 'Delete',
      selectAll: 'Select all',
      field: 'Field',
      changePassword: 'Change Password',
      userManagement: 'User Management',
      autoScaling: 'Auto scaling',
      logOut: 'Log Out',
      loading: 'Loading',
      products: 'Products',
      voiceMO: 'Voice MO',
      voiceMT: 'Voice MT',
      smsMO: 'SMS MO (msg)',
      smsMT: 'SMS MT (msg)',
      emailWithDownloadLink: "You'll receive an email with a download link when it's ready.",
      activationRequestFailed: 'Activation request failed',
      deactivationRequestFailed: 'Deactivation request failed',
      anotherRequestStillInProgress: 'Another request is still in progress.',
      confirmToAdd: '(confirm to add a new)',
      confirmToAddTag: '(confirm to add a new tag)',
      newlyCreated: 'Newly created',
      existingTags: 'Existing tags',
      copiedToClipBoard: 'Copied to your clipboard',
      upload: 'Upload',
      download: 'Download',
      total: 'Total',
    },
    rSimInventory: {
      details: {
        tabs: {
          general: 'General',
          location: 'Location',
          sessionHistory: 'Session History',
          historyAnalysis: 'History Analysis',
        },
      },
      imsiNotValid: 'rSIM profile IMSI is missing',
      imsiMissing: 'Data unavailable: SIM profile IMSI is missing',
      activeProfile: 'Active Profile',
      lastSwitch: 'Last Switch',
      lastIpAddress: 'Last IP address',
      title: 'rSIM',
      rSimInventory: 'rSIM Inventory',
      rSIMDetails: 'rSIM Details',
      uploadFinishedAt: 'Upload finished at',
      rsimStatus: 'rSIM Status',
      lastPolling: 'Last Polling',
      lastPollingTimestamp: 'Last Polling Timestamp',
      subscriptionStatus: 'Subscription Status',
      active: 'Active',
      inactive: 'Inactive',
      primaryProfileActive: 'Primary connected',
      secondaryProfileActive: 'Backup connected',
      primaryProfileDisconnected: 'Inactive - last active: Primary',
      secondaryProfileDisconnected: 'Inactive - last active: Secondary',
      lastActiveProfile: 'Last active',
      primary: 'primary',
      backup: 'backup',
      RSIMDetails: '',
      configuration: 'Configuration',
      customConfigurationDetected: 'Custom configuration detected',
      configurationChangePending: 'Configuration change pending',
      noConfigurationApplied: 'No configuration applied',
      configurationDetails: 'Configuration details',
      restoreConfiguration: 'Restore configuration',
      restoreConfigurationSend: 'Restore configuration sent',
      restoreConfigurationFailed: 'Restore configuration failed',
      usageChartTitle: 'Average session throughput',
      usageChartInput: 'Data Download',
      usageChartOutput: 'Data Upload',
      pollingChartTitle: 'Polling data',
      pollingChartAcknowledged: 'Acknowledged',
      pollingChartNotAcknowledged: 'Not acknowledged',
      sessionChartTitle: 'Sessions',
      sessionChartFinalized: 'Finalised session',
      sessionChartNotFinalized: 'Unfinalised session',
      sessionChartZeroByte: 'Zero-byte session',
      currentlyAppliedConfiguration: 'Currently applied configuration',
      connectionDelayEventCounter: 'Connection delay event counter',
      requestedPoolInterval: 'Reqested poll interval',
      commsCheckEventCounter: 'Comms check event counter',
      maxConsecutiveFailedPoll: 'Max consecutive failed poll',
      backupCancellationDelayEventCounter: 'Backup cancellation delay event counter',
      maxGlobalSwapCounter: 'Max global swap counter',
      resilienceRestorationDelayEventCounter: 'Resilience restoraton delay event counter',
      maxRandConnectionDelayEventCounter: 'Random connection delay event counter',
      maxRandBackupCancellationDelayEventCounter: 'Random backup cancellation delay event counter',
      rSimProfile: 'rSIM profile',
      otaIccid: 'OTA ICCID',
      version: 'Version',
      connectionIdFilterPlaceholder: 'Search Connection ID',
      orderNumberFilterPlaceholder: 'Search Order Number',
      accountFilterPlaceholder: 'Select Account Name or Account Number',
      productCodesFilterPlaceholder: 'Select Product Code',
      tagsFilterPlaceholder: 'Select Tags',
      limitOfNRecordsExceeded: 'Limit of {{n}} records exceeded',
      connectionId: 'Connection ID',
      orderNumber: 'Order Number',
      orderReference: 'Order Reference',
      rsimProducts: 'rSIM Products',
      actionStatusInfo: 'View the action status in the UI Updates',
      activationRequestSent: 'Activation request sent',
      deactivationRequestSent: 'Deactivation request sent',
      activation: 'Activation',
      deactivation: 'Deactivation',
      activationEid: 'Activate rSIM EID:',
      deactivationEid: 'Deactivate rSIM EID:',
      rsimPerformance: 'rSIM Performance',
      paused: 'Paused',
    },
    simInventory: {
      details: {
        tabs: {
          general: 'General',
          location: 'Location',
          history: 'History',
          historyAnalysis: 'History Analysis',
          auditTrail: 'Audit Trail',
        },
      },
      billingStatuses: {
        active: 'Active',
        deactivated: 'Deactivated',
        test: 'Test',
        terminated: 'Terminated',
        unknown: 'Unknown',
      },
      mnoStatuses: {
        unrecognized: 'Unrecognized',
        testReady: 'Test Ready',
        activeReady: 'Active Ready',
        active: 'Active',
        deactivated: 'Deactivated',
        terminated: 'Terminated',
        inventory: 'Inventory',
      },
      network: 'Network',
      mccMnc: 'MCC/MNC',
      servingCellID: 'Serving Cell ID',
      sessionInformation: 'Session Information',
      sessionId: 'Session ID',
      uptime: 'Uptime',
      latitude: 'Latitude',
      longitude: 'Longitude',
      area: 'Area',
      lastUpdated: 'Last Updated',
      accuracy: 'Accuracy',
      source: 'Source',
      lastKnownLocation: 'Last Known Location',
      locationNotAvailable: 'Location not available',
      locationNotAvailableText:
        "The network data received wasn't sufficient to estimate a location.\nThis can occur depending on how the device connects, and doesn't indicate a fault with the SIM or device.",
      subscriptionStatus: 'Subscription Status',
      subscriptionStatusPlaceholder: 'Select Subscription Status',
      company: 'Company',
      custom: 'Custom',
      identificationNumber: 'Identification number',
      identificationNumbers: 'Identification numbers',
      mobileNetworkOperator: 'Mobile Network Operator',
      mobileNetworkOperatorSectionLabel: 'Mobile network operator',
      selectStatus: 'Select Status',
      sim: 'SIM',
      simInventory: 'SIM Inventory',
      simStatus: 'SIM status',
      mnoStatusEntryTime_flat: 'MNO Status Entry Time',
      mnoStatusEntryTime_combined: 'Entry Time',
      subscriptionPackageName: 'Subscription package name',
      title: 'SIM',
      changeStatusTime: 'Change Status Time',
      enterprise: 'Enterprise',
      organisation: 'Organisation',
      organisationNumber: 'Organisation Number',
      organisationName: 'Organisation Name',
      subscriptionName: 'Subscription Name',
      mnoStatus: 'MNO Status',
      mnoStatusEntryTime: 'MNO Status Entry Time',
      mnoRatePlan: 'MNO Rate Plan',
      shippedDate: 'Shipped Date',
      firstActivationDate: 'First Activation Date',
      lastSessionDetails: 'Last session details',
      sessionDetails: 'Session details',
      sessionStatus: 'Session Status',
      sessionStatusLastUpdated_flat: 'Session Status Last Updated',
      sessionStatusLastUpdated_combined: 'Last Updated',
      sessionStartTime: 'Session Start Time',
      sessionEndTime: 'Session End Time',
      accountIdentifier: 'Account Identifier',
      rasClient: 'RAS Client',
      framedProtocol: 'Framed Protocol',
      nasIpAddress: 'NAS IP Address',
      serviceType: 'Service Type',
      userName: 'User Name',
      timeZone: 'Time Zone',
      usage: 'Usage (KB)',
      cumulativeInputUsage: 'Data Input (KB)',
      cumulativeOutputUsage: 'Data Output (KB)',
      cumulativeUsage: 'Cumulative Usage (KB)',
      eventTimestamp: 'Event Timestamp',
      ratType: 'RAT Type',
      radioAccessType: 'Radio Access Type',
      device: 'Device',
      detectedImei: 'Detected IMEI',
      imei: 'IMEI',
      managementIp: 'Management IP ',
      currentIp: 'Current IP',
      apn: 'APN',
      location: 'Last Location',
      client: 'Client',
      simProfile: 'SIM profile',
      profileStatus: 'Profile status',
      lastUpdateTime: 'Last Update Time',
      updatePending: 'Update Pending',
      SIMDetails: 'SIM Details',
      customerCommsPlan: 'Customer Comms Plan',
      commsPlan: 'Comms Plan',
      unknown: 'Unknown',
      inSession: 'In Session',
      disconnected: 'Disconnected',
      maxSimProfilesCountError: 'Limit of {{maxSimProfiles, number}} records per download exceeded',
      connectionId: 'Connection ID',
      orderNumber: 'Order Number',
      averageSessionThroughput: 'Average session throughput',
      customerReference: 'Customer Reference',
      order: 'Order',
      averageSessionChartTitle: 'Average session throughput',
      averageSessionChartInput: 'Data Download',
      averageSessionChartOutput: 'Data Upload',
      sessionChartTitle: 'Sessions',
      sessionChartFinalized: 'Finalised session',
      sessionChartNotFinalized: 'Unfinalised session',
      sessionChartZeroByte: 'Zero-byte session',
      profileUsageInCycle: 'Profile usage in cycle',
      usageInCycle: 'Usage in cycle',
      lastRat: 'Last RAT',
      networkIdentifiers: 'Network identifiers',
      homeNetwork: 'Home Network',
      lastRoamingNetwork: 'Last Roaming Network',
      countryIso: 'Country / ISO',
      region: 'Region',
      mcc: 'MCC',
      mnc: 'MNC',
      plmn: 'PLMN',
      roamingCode: 'Roaming Code',
      customFields: 'Custom fields',
      simType: 'SIM Type',
      activeConfiguration: 'Active Configuration',
      servicePlan: 'Service Plan',
      firstActivationTime: 'First Activation Time',
      productCode: 'Product Code',
      productType: 'Product Type',
      accountFilterPlaceholder: 'Select Account Name or Account Number',
      productCodesFilterPlaceholder: 'Select Product Code',
      mnoFilterPlaceholder: 'Select MNO',
      mnoFilterStatusPlaceholder: 'Select MNO Status',
      tagsFilterPlaceholder: 'Select Tags',
      labelFilterPlaceholder: 'Search Label',
      connectionIdFilterPlaceholder: 'Search Connection ID',
      orderNumberFilterPlaceholder: 'Search Order Number',
      select: 'Select',
      search: 'Search',
      limitOfNRecordsExceeded: 'Limit of {{n}} records exceeded',
      anotherBackgroundExportIsStillInProgress: 'Another background export is still in progress.',
      pleaseTryAgainLater: 'Please try again later.',
      activation: 'Activation',
      deactivation: 'Deactivation',
      activationIccid: 'Activate SIM',
      deactivationIccid: 'Deactivate SIM',
      simInventoryExport: 'SIM inventory export',
      requestOfNSimsExport:
        'We’ll process your request of <1>{{numberOfCards}}</1> SIMs export in the background.',
      exportingNSims: 'Exporting {{numberOfCards}} SIMs',
      monthlyUsage: 'Monthly Usage',
      dailyUsage: 'Daily Usage',
    },
    graphs: {
      interimDetails: 'Interim details',
      interimType: 'Interim type',
      timestamp: 'Timestamp',
      dailyUsageTooltipTitle: 'Usage data received daily',
      dailyUsageLastUpdated: 'Last updated: {{date}}',
      usageTypes: {
        data: 'Data',
        voice: 'Voice',
        sms: 'SMS',
      },
      periodTypes: {
        sevenDays: '7 days',
        twoDays: '48 h',
      },
      switchToDailyUsage: 'Switch to daily usage',
      switchToCumulativeUsage: 'Switch to cumulative usage',
      performanceChartLabels: {
        primary: 'Primary',
        backup: 'Backup',
        disconnected: 'Disconnected',
      },
    },
    customFields: {
      admin: 'Admin',
      customFields: 'Custom fields',
      enabled: 'Enabled',
      fieldName: 'Field Name',
      fieldType: 'Field Type',
      values: 'Values',
      action: 'Action',
      text: 'Text',
      dropdown: 'Drop-down list',
      edit: 'Edit',
      delete: 'Delete',
      save: 'Confirm changes',
      create: 'Create custom field',
      cancel: 'Cancel',
      addCustomField: 'Add custom field',
      selectFieldType: 'Select field type',
      typeFieldName: 'Type field name',
      unavailableWhileEditing: 'Unavailable while editing',
      customFieldsLimitReached: 'Custom fields limit reached',
      fieldNameTaken: 'Field name taken',
      fieldNameEmpty: 'Field name empty',
      saveError: 'Please fill all required fields',
      deleteCustomField: 'Delete custom field',
      deleteCustomFieldDescription:
        'Deleting the custom field {{name}} will remove all values assigned to it.',
      dropdownModal: {
        title: 'Edit drop-down list values',
        removeTitle: 'Delete drop-down list value',
        removeDescription:
          'Deleting the value <strong>{{label}}</strong> will remove it from associated SIM cards.',
        textFieldLabel: 'Create new value',
        valueNameTaken: 'Value name taken',
        confirmNewValue: 'Confirm to add a new value',
      },
      addDropdownListValues: 'Add drop-down list values',
      unsavedChangesModal: {
        title: 'Unsaved changes',
        subtitle: 'Are you sure you want to leave without saving?',
        cancel: 'Keep editing',
        confirm: 'Leave',
      },
    },
    auditTrail: {
      tableHeaders: {
        field: 'Field',
        changedFrom: 'Changed From',
        changedTo: 'Changed To',
        effectiveTime: 'Effective Time',
        source: 'Source',
        userName: 'User Name',
      },
    },
    admin: {
      rSimManufacturingFile: {
        rSimManufacturingFile: 'rSIM manufacturing file',
        dragAndDropFileOr: 'Drag and drop file or',
        browse: 'Browse',
        clear: 'Clear',
        upload: 'Upload',
        uploadNewFile: 'Upload new file',
        downloadResults: 'Download results',
        rSimManufacturingFilename: 'rSIM manufacturing file.out',
        processingFailedInvalidData: 'Processing failed - invalid data',
        failedToDownloadTheFile: 'Failed to download the file',
        fileProcessedSuccessfully: "File '{{filename}}' processed successfully",
        fileProcessed: "File '{{filename}}' processed",
        fileUploadFailed: "File '{{filename}}' upload failed",
        downloadTheResultsFileToSeeDetails: 'Download the results file to see details',
        wrongFileFormat: 'Wrong file format - only .out files are accepted',
      },
      subscriptionStatusReconciliation: {
        subscriptionStatusReconciliation: 'Subscription Status Reconciliation',
        dragAndDropFileOr: 'Drag and drop file or',
        browse: 'Browse',
        clear: 'Clear',
        upload: 'Upload',
        selectFile: 'Select a CSV file',
        fileProcessedSuccessfully: "File '{{filename}}' processed successfully",
        fileUploadFailed: "File '{{filename}}' upload failed",
        processedWithSkipped: 'Processed: {{processed}}, Skipped: {{skipped}}',
        history: 'Upload history',
        processedAt: 'Processed at',
        processedBy: 'Processed by',
        processed: 'Processed',
        skipped: 'Skipped',
      },
    },
    products: {
      common: {
        productCode: 'Product Code',
      },
      tabs: {
        general: 'General',
        location: 'Location',
        history: 'History',
        historyAnalysis: 'History Analysis',
        auditTrail: 'Audit Trail',
      },
      sim: {
        simProducts: 'SIM Products',
        viewDetails: 'View details',
        dataMB: 'Data (MB)',
        dataMT: 'Data Download (MB)',
        dataMO: 'Data Upload (MB)',
        voiceMO: 'Voice (MO)',
        voiceMT: 'Voice (MT)',
        smsMO: 'SMS MO (msg)',
        smsMT: 'SMS MT (msg)',
        lastKnownIP: 'Last Known IP',
        orderReference: 'Order Reference',
        actions: {
          action: 'Action',
          activate: 'Activate',
          activation: 'activation',
          suspend: 'Suspend',
          suspension: 'suspension',
          unsuspend: 'Unsuspend',
          unsuspension: 'unsuspension',
          terminate: 'Terminate',
          termination: 'termination',
          sendCancelLocation: 'Send Cancel Location',
          cancelLocation: 'Cancel Location',
          locationCancellation: 'location cancellation',
          confirmDialog: {
            description_other:
              'A total of <1>{{count, number}} SIMs</1> will be submitted for {{action}}.',
            description_one:
              'A total of <1>{{count, number}} SIM</1> will be submitted for {{action}}.',
            warningNotSupportedAction: 'Some of the selected SIMs don’t allow {{action}}.',
            excludedSIM_other: 'Excluded SIMs ({{count, number}})',
            excludedSIM_one: 'Excluded SIM ({{count, number}})',
            subtitle_one: '{{count, number}} SIM selected',
            subtitle_other: '{{count, number}} SIMs selected',
          },
          snackbars: {
            success: {
              title: '{{action}} request received',
              description: 'View the action status in the action audit trail',
            },
            fail: {
              title: '{{action}} request failed',
              description: 'Something went wrong',
            },
          },
        },
      },
      rSim: {
        rSimExport: 'rSIM export',
        requestOfNRSimsExport:
          'We’ll process your request of <1>{{numberOfCards}}</1> rSIMs export in the background.',
        exportingNRSims: 'Exporting {{numberOfCards}} rSIMs',
        maxRSimProductsCount: 'Limit of {{maxRSims, number}} records per download exceeded',
        actions: {
          action: 'Action',
          activate: 'Activate',
          suspend: 'Suspend',
          unsuspend: 'Unsuspend',
          terminate: 'Terminate',
          sendCancelLocation: 'Send Cancel Location',
          cancelLocation: 'Cancel Location',
          confirmDialog: {
            description_other:
              'A total of <1>{{count, number}} rSIMs</1> will be submitted for {{action}}.',
            description_one:
              'A total of <1>{{count, number}} rSIM</1> will be submitted for {{action}}.',
            warningNotSupportedAction: 'Some of the selected rSIMs don’t allow {{action}}.',
            excludedSIM_other: 'Excluded rSIMs ({{count, number}})',
            excludedSIM_one: 'Excluded rSIM ({{count, number}})',
            subtitle_one: '{{count, number}} rSIM selected',
            subtitle_other: '{{count, number}} rSIMs selected',
          },
          snackbars: {
            success: {
              title: '{{action}} request received',
              description: 'View the action status in the action audit trail',
            },
          },
        },
      },
      eSim: {
        details: {
          title: 'eSim {{eid}}',
          locationName: 'eSIM Details',
          rootLocationName: 'eSIM Products',
          setcions: {
            esim: {
              title: 'eSim',
              eid: 'EID',
            },
          },
        },
        eSimProfile: 'eSIM profile',
        filters: {
          search: 'Search EID',
        },
        inventory: {
          cells: {
            eSimProfile: {
              enabled: 'Enabled',
              disabled: 'Disabled',
            },
          },
          actions: {
            enable: {
              title: 'Enable Profile',
              description:
                "You are about to enable profile <1>{{iccid}}</1>.\nCurrently enabled profile will be automatically disabled.\nThis may briefly interrupt the device's connection.",
              success: {
                title: 'Request received',
                description: 'This process may take a few moments to complete.',
              },
            },
            addESimProfile: {
              title: 'Add New Profile',
            },
            deleteESimProfile: {
              title: 'Delete eSIM profile',
              description:
                'Are you sure you want to delete profile <1>{{iccid}}</1>?\n This action is permanent and cannot be undone.',
              deleteProfile: 'Delete Profile',
            },
          },
        },
      },
    },
    simProfiles: {
      profiles: 'Profiles',
      simProfiles: 'SIM Profiles',
    },
    pages: {
      expiredLink: {
        expiredLinkErrorMessage: 'The link you followed is unavailable or has expired',
      },
      maintenance: {
        title: 'Maintenance Mode',
        messageForUser:
          'Platform is currently under maintenance.\nWe are working to improve your experience.\nPlease check back in a few minutes.',
      },
    },
    sessionHistory: {
      errors: {
        dataUnavailable: 'Data unavailable',
        imsiMissing: 'SIM profile IMSI is missing',
      },
    },
  },
};
